import loadable from '@loadable/component'

export default [
  {
    path: '/AboutToPlay',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-AboutToPlay" */ '~/pages/AboutToPlay')
    ),
  },
  {
    path: '/AboutToPlay/Rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AboutToPlay-Rules" */ '~/pages/AboutToPlay/Rules'
        )
    ),
  },
  {
    path: '/LudoSkin',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LudoSkin" */ '~/pages/LudoSkin')
    ),
  },
  {
    path: '/LudoQualifying',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoQualifying" */ '~/pages/LudoQualifying'
        )
    ),
  },
  {
    path: '/LudoFamilyCreate',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoFamilyCreate" */ '~/pages/LudoFamilyCreate/pages/Main'
        )
    ),
  },
  {
    path: '/LudoFamilyCreate/form',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoFamilyCreate-FormPage" */ '~/pages/LudoFamilyCreate/pages/FormPage'
        )
    ),
  },
  {
    path: '/LudoFamilyCreate/rewards',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoFamilyCreate-rewards" */ '~/pages/LudoFamilyCreate/pages/Reward'
        )
    ),
  },
  {
    path: '/LudoFamilyCreate/join',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoFamilyCreate-join" */ '~/pages/LudoFamilyCreate/pages/JoinFamily'
        )
    ),
  },
  {
    path: '/DiminoSkin',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-DiminoSkin" */ '~/pages/LudoGamesBoot/DiminoSkin'
        )
    ),
  },
  {
    path: '/LudoTurntable',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoTurntable" */ '~/pages/LudoTurntable'
        )
    ),
  },
  {
    path: '/LudoTurntable/Skin',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LudoTurntable-Skin" */ '~/pages/LudoTurntable/Skin'
        )
    ),
  },
  {
    // 金币版ludo冷启
    path: '/GoldLudoCoolBoot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GoldLudoCoolBoot" */ '~/pages/GoldLudoCoolBoot'
        )
    ),
  },
  {
    // 金币版ludo冷启-背包
    path: '/GoldLudoCoolBoot/bag',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GoldLudoCoolBoot-bag" */ '~/pages/GoldLudoCoolBoot/Bag'
        )
    ),
  },
  {
    // 消消乐冷启
    path: '/BingoCoolBoot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BingoCoolBoot" */ '~/pages/LudoGamesBoot/BingoColdBoot'
        )
    ),
  },
  {
    // Uno冷启
    path: '/UnoCoolBoot',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-Uno" */ '~/pages/LudoGamesBoot/Uno')
    ),
  },
  {
    // 消消乐冷启-虚拟形象
    path: '/BingoColdBootV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BingoColdBootV2" */ '~/pages/LudoGamesBoot/BingoColdBootV2'
        )
    ),
  },
]
